import React from "react";
import { Switch } from "react-router-dom";
import AuthRoute from "./AuthRoute";
import RecruiterCandidates from "../../../pages/recruiter/Candidates";

import RECNew from "../../../pages/recruiter/dashboard/New";
import RECSTC from "../../../pages/recruiter/dashboard/Stc";
import RECDocumentColleted from "../../../pages/recruiter/dashboard/DocumentColleted";
import RECFinalInterviewScheduled from "../../../pages/recruiter/dashboard/FinalInterviewScheduled";
import RECFinalInterviewCompleted from "../../../pages/recruiter/dashboard/FinalInterviewCompleted";
import RECScheduleInterview from "../../../pages/recruiter/dashboard/ScheduleInterview";
import RECInterviewScheduled from "../../../pages/recruiter/dashboard/InterviewScheduled";
import RECJoined from "../../../pages/recruiter/dashboard/Joined";
import RECOffered from "../../../pages/recruiter/dashboard/Offered";
import RECOfferedDeclined from "../../../pages/recruiter/dashboard/OfferedDeclined";
import RECSalaryBreakup from "../../../pages/recruiter/dashboard/SalaryBreakup";
import RECYetToJoin from "../../../pages/recruiter/dashboard/YetToJoin";

import Search from "../../../pages/recruiter/Search";
import Dashboard from "../../../pages/dashboard";
import ParsedResume from "../../Candidates/ParsedResume";
import Singlechat from "../../../pages/chat/Singlechat";
import EmployeeDashboard from "../../../pages/dashboard/dashboardItems/EmployeeDashboard";

import ApplyLeave from "../../../pages/employee/attendance/ApplyLeave";
import MyOpinions from "../../../pages/employee/opinions/MyOpinions";
import MyFeedback from "../../../pages/employee/opinions/MyFeedback";
import MyConcern from "../../../pages/employee/opinions/MyConcern";
import ApplyPermission from "../../../pages/employee/attendance/ApplyPermission";
import CalendarUI from "../../../pages/employee/calender/CalendarUI";
import MyAppreciation from "../../../pages/employee/certificates/MyAppreciation";
import ProjectDetails from "../../../pages/employee/projectDetails/ProjectDetails";
import Profile from "../../../pages/employee/UserDetails/UserDetails";
import EmployersCertificate from "../../../pages/employee/ViewEmployeeCertificate/EmployersCertificate";
import ViewAttendanceDetails from "../../../pages/employee/attendance/ViewAttendanceDetails";
import ViewJobposting from "../../../pages/employee/internalJobposting/ViewJobposting";
import SeparationTemplate from "../../../pages/employee/separation/SeparationTemplate";
import ViewMyPaySlip from "../../../pages/employee/payslip/ViewMyPaySlip";
import { Route } from "react-router-dom";
import { EmployeeDataProvider } from "../../../context/EmployeeDataContext";
import PolicyHandBook from "../../../pages/employee/PolicyHandbook/PolicyHandBook";
import EmployeeTaxDocument from "../../../pages/employee/TaxDocument/EmployeeTaxDocument";
import EmployeeAssetManagement from "../../../pages/employee/assetManagement/EmployeeAssetManagement";

const RecruiterRoutes = ({ role }) => {
  return (
    <Switch>
      <AuthRoute
        path="/app/search"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Search}
      />
      <AuthRoute
        path="/app/dashboard"
        role={role}
        roles={[
          "SUPERADMIN",
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={Dashboard}
      />

      <AuthRoute
        path="/app/employee_dashboard"
        role={role}
        roles={[
          "SUPERADMIN",
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={EmployeeDashboard}
      />
      <AuthRoute
        path="/app/singlechat"
        role={role}
        roles={["SUPERADMIN", "ADMIN", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Singlechat}
      />
      <AuthRoute
        path="/app/parsed_resume"
        role={role}
        roles={[
          "ADMIN",
          "RECRUITER",
          "CLIENTCOORDINATOR",
          "FREELANCER",
          "SUBVENDOR",
        ]}
        component={ParsedResume}
      />

      <AuthRoute
        path="/app/recruiter_candidates"
        role={role}
        roles={["RECRUITER"]}
        component={RecruiterCandidates}
      />
      <AuthRoute
        path="/app/recruiter_candidates_new"
        role={role}
        roles={["RECRUITER"]}
        component={RECNew}
      />
      <AuthRoute
        path="/app/recruiter_candidates_stc"
        role={role}
        roles={["RECRUITER"]}
        component={RECSTC}
      />
      <AuthRoute
        path="/app/recruiter_candidates_schedule_interview"
        role={role}
        roles={["RECRUITER"]}
        component={RECScheduleInterview}
      />
      <AuthRoute
        path="/app/recruiter_candidates_interview_scheduled"
        role={role}
        roles={["RECRUITER"]}
        component={RECInterviewScheduled}
      />
      <AuthRoute
        path="/app/recruiter_candidates_fis"
        role={role}
        roles={["RECRUITER"]}
        component={RECFinalInterviewScheduled}
      />
      <AuthRoute
        path="/app/recruiter_candidates_fic"
        role={role}
        roles={["RECRUITER"]}
        component={RECFinalInterviewCompleted}
      />
      <AuthRoute
        path="/app/recruiter_candidates_document_collected"
        role={role}
        roles={["RECRUITER"]}
        component={RECDocumentColleted}
      />
      <AuthRoute
        path="/app/recruiter_candidates_salary_breakup_shared"
        role={role}
        roles={["RECRUITER"]}
        component={RECSalaryBreakup}
      />
      <AuthRoute
        path="/app/recruiter_candidates_offered"
        role={role}
        roles={["RECRUITER"]}
        component={RECOffered}
      />
      <AuthRoute
        path="/app/recruiter_candidates_joined"
        role={role}
        roles={["RECRUITER"]}
        component={RECJoined}
      />
      <AuthRoute
        path="/app/recruiter_candidates_offer_declined"
        role={role}
        roles={["RECRUITER"]}
        component={RECOfferedDeclined}
      />
      <AuthRoute
        path="/app/recruiter_candidates_yet_to_join"
        role={role}
        roles={["RECRUITER"]}
        component={RECYetToJoin}
      />

      <Route path="/app/opinions">
        <AuthRoute
          path=""
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyOpinions}
        />
        <AuthRoute
          path="/app/opinions/feedback"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyFeedback}
        />
        <AuthRoute
          path="/app/opinions/concern"
          role={role}
          roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
          component={MyConcern}
        />
      </Route>
      <AuthRoute
        path="/app/apply-leave"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyLeave}
      />
      <AuthRoute
        path="/app/apply-permission"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ApplyPermission}
      />
      <AuthRoute
        path="/app/calendar"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={CalendarUI}
      />
      <Route
        path="/app/payslip"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewMyPaySlip}
      />
      <Route
        path="/app/appreciations"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={MyAppreciation}
      />
      <Route
        path="/app/project-details"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ProjectDetails}
      />
      <Route
        path="/app/profile"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={Profile}
      />
      <Route
        path="/app/my-appreciations"
        role={role}
        roles={["EMPLOYEE"]}
        component={EmployersCertificate}
      />
      <Route
        path="/app/attendance"
        role={role}
        roles={["EMPLOYEE"]}
        component={ViewAttendanceDetails}
      />
      <Route
        path="/app/jobpostings"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={ViewJobposting}
      />
      <Route
        path="/app/policy-handbook"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={PolicyHandBook}
      />
      <Route
        path="/app/separation"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={SeparationTemplate}
      />
      <Route
        path="/app/tax-document"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeTaxDocument}
      />
      <Route
        path="/app/company-assets"
        role={role}
        roles={["EMPLOYEE", "RECRUITER", "CLIENTCOORDINATOR"]}
        component={EmployeeAssetManagement}
      />

      {/* Add more routes specific to RECRUITER here */}
    </Switch>
  );
};

export default RecruiterRoutes;
